import { AppBar, Box/*, useTheme*/ } from '@mui/material'
import LogoBox from '@components/common/LogoBox'
//import CustomButtonBox from '@components/common/CustomButtonBox'
import SearchBar from '@components/common/SearchBar'
//import Vector from '@assets/header_dashboard/Vector.svg'
import BackToSitesButton from './BackToSitesButton'

export default function CustomHeader({
  route,
  executeSearch,
}: {
  route?: string
  executeSearch?: (value: string) => void
}) {
//  const theme = useTheme()

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: 'transparent',
        boxShadow: 'none',
        pt: '22px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
            alignItems: 'center',
          }}
        >
          {/*<CustomButtonBox
            icon={Vector}
            text="ניהול ווידג'טים"
            borderColor="#E4E7EB"
            textColor={theme.palette.text.primary}
          />*/}
          <SearchBar
            route={route}
            placeholder="הקלד מספר מד, כרטיס מים או כתובת"
            executeSearch={executeSearch}
          />
        </Box>
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}
        >
          <LogoBox />
          <BackToSitesButton />
        </Box>
      </Box>
    </AppBar>
  )
}
